<template>
    <div>
        <button
            class="btn btn-sm btn-yokumiru-orange"
            @click="openModal">
            新規{{ $locale.consultation_host }}予約
        </button>
    </div>
</template>

<script>
    import { mapMutations } from 'vuex'

    export default {
        props: {
            user: {
                type: Object,
                required: true,
            },
        },

        created: function () {
            this.setUser(this.user)
        },

        methods: {
            openModal: function () {
                bus.$emit('open-modal-doctor-reservation-doctor-menu')
            },

            ...mapMutations({
                setUser: 'doctorReservation/setUser',
            }),
        },
    }
</script>
